import { Box, Chip, Paper, Typography } from "@mui/material";
import {
  ErrorOutlineRounded,
  TrendingUpRounded,
  LightbulbRounded,
} from "@mui/icons-material";
import { palette, theme  as colorTheme} from "../../../../Convoze.theme";


const ui = {
  // text: "#111827",
  text : colorTheme('palette', 'night').value,
  // subtext: "#6b7280",
  subtext:colorTheme('palette', 'secondary').value,
  border: "#e7e5ef",
  rowBg:
    "linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(248,249,255,0.85) 100%)",
};

function Pill({ label }) {
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        height: 24,
        bgcolor: "#eef2ff",
        // color: "#4f46e5",
        color:colorTheme('palette', 'primary').value,
        border: "1px solid #e0e7ff",
        "& .MuiChip-label": { px: 1 },
        fontWeight: 700,
      }}
    />
  );
}

function PriorityChip({ level }) {
  if (level === "high") {
    return (
      <Chip
        size="small"
        icon={<ErrorOutlineRounded />}
        label="high"
        sx={{
          height: 26,
          bgcolor: "#fee2e2",
          // color: "#dc2626",
          color:colorTheme('palette', 'negative').value,
          mt: 1,
          border: "1px solid #fecaca",
          "& .MuiChip-icon": { color: colorTheme('palette', 'negative').value, ml: 0.5 },
          fontWeight: 700,
        }}
      />
    );
  }
  if (level === "medium") {
    return (
      <Chip
        size="small"
        icon={<TrendingUpRounded />}
        label="medium"
        sx={{
          height: 26,
          mt: 1,
          bgcolor: "#fef3c7",
          // color: "#d97706",
          color:colorTheme('palette', 'neutral').value,
          // border: "1px solid #fde68a",
          border : `1px solid ${colorTheme('palette', 'neutralBg').value}`,
          "& .MuiChip-icon": { 
            // color: "#d97706",
            color:colorTheme('palette', 'neutral').value,
             ml: 0.5 },
          fontWeight: 700,
        }}
      />
    );
  }
  return (
    <Chip
      size="small"
      icon={<LightbulbRounded />}
      label="low"
      sx={{
        mt: 1,
        height: 26,
        bgcolor: "#f3f4f6",
        color: "#6b7280",
        border: "1px solid #e5e7eb",
        "& .MuiChip-icon": { color: "#6b7280", ml: 0.5 },
        fontWeight: 700,
      }}
    />
  );
}

export default function AISuggestionItem({
  title,
  description,
  tag,
  priority,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 5,
        p: { xs: 1.5, sm:"1rem" },
        backgroundColor: "#FAFAFB",
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 600, fontSize: "0.9rem" }}
        >
          {" "}
          {title}
        </Typography>

        <PriorityChip level={priority} />
      </Box> */}

      <Typography
        variant="subtitle2"
        sx={{
          fontSize: "0.87rem",
          lineHeight: "1.25rem",
        }}
      >
        {description}
      </Typography>

      {/* <Pill label={tag} /> */}
    </Paper>
  );
}
